import {Injectable} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {SlowConnectionSnackBarComponent} from '@shared/components/slow-connection-snack-bar/slow-connection-snack-bar.component';

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {

  constructor(private _snackBar: MatSnackBar) {
  }

  public openSnackBar(message: string): void {
    this._snackBar.openFromComponent(SlowConnectionSnackBarComponent, {
      duration: 10000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      data: {message}
    });
  }

}
